import { consumeSessionHandoff } from './lib/sessionHandoff'
import { StrictMode } from 'react'
import './i18n/index.ts'
import { createRoot } from 'react-dom/client'
import 'remixicon/fonts/remixicon.css'
import './index.css'

void consumeSessionHandoff().finally(() => {
  void import('./App.tsx').then(({ default: App }) => {
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <App />
      </StrictMode>,
    )
  })
})
